import BaseService from './baseService';

export default {
  aprovarRejeitarConcordataFalencia(concordataFalencia) {
    return BaseService.post("qualificacaoEconomica/aprovarRejeitarConcordataFalencia",concordataFalencia)
  },
  aprovarRejeitarBalanco(balanco) {
    return BaseService.post("qualificacaoEconomica/aprovarRejeitarBalancoFinanceiro",balanco)
  },
};
